import { Routes } from '@angular/router';
import { AuthenticationGuard } from './shared/guards/authentication/authentication-guard.service';
import { IsLoggedInGuard } from './shared/guards/authentication/is-logged-in.guard';

export const APP_ROUTES: Routes = [
  { path: 'login', loadChildren: () => import('./features/login/login.routes').then(m => m.LOGIN_ROUTES), canActivate: [IsLoggedInGuard] },
  { path: '', loadChildren: () => import('./features/home/home.routes').then(m => m.HOME_ROUTES), canActivate: [AuthenticationGuard] },
  { path: 'reports', loadChildren: () => import('./features/reports/reports.routes').then(m => m.REPORTS_ROUTES) },
  { path: 'report-download', loadChildren: () => import('./features/reports/modules/report-download/report-download.routes').then(m => m.REPORT_DOWNLOAD_ROUTES) },
  { path: 'report-edit', loadChildren: () => import('./features/reports/modules/report-edit/report-edit.routes').then(m => m.REPORT_EDIT_ROUTES) },
  { path: 'dashboard', loadChildren: () => import('./features/ocfa/modules/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES) },
];
